var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCultureIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 62,
    viewBox: "0 0 66 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 0.791992,
    width: 65.3461,
    height: 61,
    rx: 16,
    fill: "#F7F6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8727 29.8556C23.8727 31.187 22.7957 32.264 21.4643 32.264H18.8713C17.5399 32.264 16.4629 31.187 16.4629 29.8556C16.4629 28.5242 17.5399 27.4473 18.8713 27.4473H21.4643C22.7957 27.4473 23.8727 28.5242 23.8727 29.8556Z",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.654 34.2538C24.654 35.3517 23.7617 36.2439 22.6638 36.2439H19.2343C18.1364 36.2439 17.2441 35.3517 17.2441 34.2538C17.2441 33.1559 18.1364 32.2637 19.2343 32.2637H22.6638C23.7617 32.2637 24.654 33.1559 24.654 34.2538Z",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4899 38.0017C26.4899 38.9706 25.7022 39.7583 24.7333 39.7583H20.8367C19.8678 39.7583 19.0801 38.9706 19.0801 38.0017C19.0801 37.0328 19.8678 36.2451 20.8367 36.2451H24.7333C25.7022 36.2451 26.4899 37.0328 26.4899 38.0017Z",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3267 41.5249C28.3267 42.5008 27.5355 43.2919 26.5596 43.2919H22.7188C21.7255 43.2919 20.9169 42.5008 20.9169 41.5249C20.9169 40.549 21.722 39.7578 22.7188 39.7578H26.5596C27.5355 39.7578 28.3267 40.549 28.3267 41.5249Z",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3758 43.292L32.088 43.2049C34.2698 43.2049 36.3645 42.337 37.905 40.7965L39.5118 40.3957H42.6974V26.1058H32.4191L27.9718 20.9301C27.4595 19.9263 26.4243 19.292 25.2986 19.292C23.1725 19.292 21.7191 21.4424 22.5103 23.4151L25.0581 27.4477H21.6738",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4072 30.9717C29.4072 30.9717 31.1464 34.4187 36.8972 34.4187",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8837 24.4648H42.6973V42.1529H48.8837V24.4648Z",
    stroke: "#0D4248",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultureIcon3);
export default __webpack_public_path__ + "static/media/culture-icon-3.32b15a9684df89be1af61c5b5d01a172.svg";
export { ForwardRef as ReactComponent };